import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {merge, Subscription} from 'rxjs';
import {ImportModuleSourceColumn} from '../../../core/definitions/import-module';
import {LookupKeyOptionControls} from '../lookup-controls';
import {unknownPlaceholders} from '../value-template';

/**
 * The key options of a lookup, for a lookup table whose key is not the
 * source cell verbatim: a `{Column}` template that composes the key, a
 * case-insensitive match, a suffix retried when the key misses, and
 * aliases. Editing any of them turns the lookup's key options on, so what
 * the operator fills in reaches the lookup; an option left empty sends
 * nothing.
 */
@Component({
  selector: 'app-lookup-key-options',
  templateUrl: './lookup-key-options.component.html',
  styleUrls: ['./lookup-key-options.component.scss'],
  standalone: false,
})
export class LookupKeyOptionsComponent implements OnChanges, OnDestroy {
  @Input() controls!: LookupKeyOptionControls;
  @Input() columns: ImportModuleSourceColumn[] = [];

  private optionEdits: Subscription | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['controls']) {
      this.optionEdits?.unsubscribe();
      const controls = this.controls;
      this.optionEdits = merge(
        controls.lookupKeyTemplateControl.valueChanges,
        controls.lookupCaseInsensitiveControl.valueChanges,
        controls.lookupFallbackSuffixControl.valueChanges,
        controls.lookupAliasesControl.valueChanges,
      ).subscribe(() => {
        if (!controls.lookupKeyOptionsControl.value) {
          controls.lookupKeyOptionsControl.setValue(true);
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.optionEdits?.unsubscribe();
  }

  /** `{Placeholder}` names in the key template that match no source column. */
  get unknownKeyColumns(): string[] {
    return unknownPlaceholders(
      this.controls.lookupKeyTemplateControl.value, new Set(this.columns.map(c => c.name)));
  }
}
